import { FC, ReactNode } from "react";
import { useMatches } from "src/router";
import { SpacesAccess, isSpacesAccess } from "./types";
import { useSpaceContext } from "./space-context";
import { SpaceBlockedPage } from "./space-blocked-page";

function getSpacesAccessFromMatches(
  matches: ReturnType<typeof useMatches>,
): SpacesAccess {
  // Find the deepest match that has a spacesAccess property
  const match = matches.findLast(
    (m) =>
      m.handle &&
      typeof m.handle === "object" &&
      "spacesAccess" in m.handle &&
      isSpacesAccess(m.handle.spacesAccess),
  );

  return match
    ? (match.handle as { spacesAccess: SpacesAccess }).spacesAccess
    : "neutral";
}

export const SpaceAccessGuard: FC<{
  children: ReactNode;
  spacesAccess?: SpacesAccess;
}> = ({ children, spacesAccess: overrideAccess }) => {
  const matches = useMatches();
  const { isSpacesEnabled, isInSpace } = useSpaceContext();

  const access = overrideAccess ?? getSpacesAccessFromMatches(matches);

  if (isSpacesEnabled && isInSpace && access === "hidden-from-limited-view") {
    return <SpaceBlockedPage />;
  }

  return <>{children}</>;
};
